var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:({
    transform: ("rotate(" + _vm.rotate + ")")
  }),attrs:{"version":"1.1","width":_vm.width,"height":_vm.height,"viewBox":"0 0 14 26"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('path',{attrs:{"fill":"currentColor","d":"M0,0L14,13L0,26V17Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }